<template>
  <RantaiPasokLaporan></RantaiPasokLaporan>
</template>

<script>
import RantaiPasokLaporan from "@/components/rantai_pasok_laporan/RantaiPasokLaporan";
export default {
  name: "RantaiPasokLaporanView",
  components:{
    RantaiPasokLaporan
  }
}
</script>

<style scoped>

</style>